import Remesas_monitor from "./Remesas_monitor.png";


export const imagesActTheme7 = {
	sub2: {
		act1: {
			monitor1: Remesas_monitor
		}
	}
}